import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
    Snackbar, Alert, Tooltip, IconButton
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Grid } from "@material-ui/core";
import axios from "../../../../axios-order";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import DownloadIcon from '@mui/icons-material/Download';
import LoadingButton from '@mui/lab/LoadingButton';
import VisibilityIcon from "@mui/icons-material/Visibility";
import Chip from '@mui/material/Chip';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import DraftsIcon from '@mui/icons-material/Drafts'
import Button from "@mui/material/Button";

const Quter = [
    { id: "Q1", value: `Quarter 1 Apr-Jun` },
    { id: "Q2", value: `Quarter 2 Jul-Sep` },
    { id: "Q3", value: `Quarter 3 Oct-Dec` },
    { id: "Q4", value: `Quarter 4 Jan-Mar` },
];

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
        marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        border: "1px solid #ced4da",
        fontSize: 16,
        padding: "10px 26px 10px 12px",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            borderRadius: 4,
            borderColor: "rgba(0,123,255)",
        },
    },
}));

export default function Filing24Q() {
    let history = useHistory();
    const [yearFromArr, setFromYearArr] = useState([]);
    const [year, setYear] = useState("");
    const [quarter, setQuarter] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const [showDrafts, setShowDrafts] = useState(false);
    const [isViewOnly, setIsViewOnly] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [searchTimeout, setSearchTimeout] = useState(null);




    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info'
    });

    const filteredTableData = showDrafts
        ? tableData.filter(item => item.is_draft)
        : tableData;

    useEffect(() => {
        getApiForReport();
        setFromYearValues()
    }, []);


    const setFromYearValues = () => {
        let current_year = new Date().getFullYear();
        let yearArr = [];
        for (let i = current_year - 8; i <= current_year + 2; i++) {
            let startYear = i;
            let endYear = i + 1;
            let endYearShort = endYear.toString().slice(-2);
            yearArr.push({ id: i, year: `${startYear}-${endYearShort}` });
        }
        setFromYearArr(yearArr);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };

    const handleOpenAndCloseModel = () => {
        setQuarter(null);
        setYear(null);
    };

    
     const handleBackNavigation = () => {
  history.push('/Filing');
};

    const handleDraftView = (financialYear, quarter) => {
        localStorage.setItem('financial_year_24Q', financialYear);
        localStorage.setItem('quarter_24Q', quarter);
        history.push('/24QFormFiling');
    };

    const onSubmitHandler = () => {
        setSubmitBtnLoading(true)
        axios
            .post(`/is_eligible_to_file_24q`, {
                business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
                financial_year: year,
                quarter: quarter
            })
            .then((res) => {
                if (res?.data?.status) {
                    localStorage.setItem("financial_year_24Q", `${year}`);
                    localStorage.setItem("quarter_24Q", quarter);
                    history.push({
                        pathname: `/24QFormFiling`
                    })
                } else {
                    setSnackbar({
                        open: true,
                        message: res?.data?.message,
                        severity: 'warning'
                    });
                }
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setSubmitBtnLoading(false)
            });
    };


    // Replace the onErrorFileExport function with this
    const onErrorFileExport = (errorFileBinary, errorFileType, financial_year, quarter) => {
        let contentType;
        let extension;

        switch (errorFileType?.toLowerCase()) {
            case 'json':
                contentType = 'application/json';
                extension = 'json';
                break;
            case 'xlsx':
                contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                extension = 'xlsx';
                break;
            case 'txt':
                contentType = 'text/plain';
                extension = 'txt';
                break;
        }

        const filename = `${financial_year}_${quarter}_error.${extension}`;
        downloadBase64File(contentType, errorFileBinary, filename);
    };

    // Add this function in the Filing24Q component
    const handleReset = (id, financialYear, quarter) => {
        const payload = {
            business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
            financial_year: financialYear,
            quarter: quarter
        };

        axios.post('/reset_rpu_repository_data', payload)
            .then((res) => {
                if (res?.data?.status) {
                    setSnackbar({
                        open: true,
                        message: res?.data?.message,
                        severity: 'success'
                    });
                    getApiForReport();
                } else {
                    setSnackbar({
                        open: true,
                        message: res?.data?.message,
                        severity: 'error'
                    });
                }
            })
            .catch((err) => {
                setSnackbar({
                    open: true,
                    message: err?.response?.data?.message || 'An error occurred',
                    severity: 'error'
                });
            });
    };


    const handleSearch = (event) => {
        console.log("gfhjgjkhbkjnk", 2433);

        const value = event.target.value;
        console.log("search", event);
        setSearchText(value);
        setPage(0);
        const payload = {
            business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
            number_of_rows_per_page: rowsPerPage,
            page_number: 0,
            search_txt: value
        };

        axios
            .post(`/search_option_tds_24q`, payload)
            .then((res) => {
                setTableData(res?.data?.records || []);

                const currentRecord = res?.data?.records?.find(
                    record =>
                        record.financial_year === localStorage.getItem('financial_year_24Q') &&
                        record.quarter === localStorage.getItem('quarter_24Q') &&
                        record.status.toLowerCase() === 'succeeded'
                );

                if (currentRecord) {
                    setIsViewOnly(true);
                }
            })
            .catch((err) => {
                console.log(err);
                setTableData([]);
            });
    };

    useEffect(() => {
        return () => {
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }
        };
    }, [searchTimeout]);

    const getApiForReport = () => {
        axios
            .get(`/get_24q_filing_data/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                setTableData(res?.data?.records || []);
            })
            .catch((err) => {
                console.log(err);
                setTableData([]);
            });
    };

    const onTextFileExport = (txtFileBinary, financial_year, quarter) => {
        const filename = `${financial_year}_${quarter}.txt`;
        downloadBase64File('text/plain', txtFileBinary, filename);
    };

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const onFUVFileExport = (fvuFileBinary, financial_year, quarter) => {
        const filename = `${financial_year}_${quarter}.zip`;
        downloadBase64File('application/zip', fvuFileBinary, filename);
    }

    const onReceiptFileExport = (receiptFileBinary, financial_year, quarter) => {
        const filename = `${financial_year}_${quarter}.pdf`;
        downloadBase64File('application/pdf', receiptFileBinary, filename);
    }

    const onExportFileExport = (errorFileBinary) => {
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `Form24q Error Filing Report.xlsx`;
        downloadBase64File(contentType, errorFileBinary, filename);
    }

    return (
        <React.Fragment>
             <div style={{
                                  padding: "15px 20px",
                                  backgroundColor: "#f5f5f5"
                                }}>
                                   <Tooltip title="Back" arrow>
                                                          <IconButton
                                                           onClick={handleBackNavigation}
                                                            sx={{
                                                              borderRadius: '50%',
                                                              padding: '6px',
                                                              color: '#263238',
                                                              fontSize: '20px',
                                                              backgroundColor: '#ffffff',
                                                              height: '36px',
                                                              width: '36px',
                                                              '&:hover': {
                                                                backgroundColor: '#455a64',
                                                                color: '#ffffff',
                                                              },
                                                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                                              transition: 'background-color 0.3s ease',
                                                            }}
                                                          >
                                                            <ArrowBackIcon sx={{ fontSize: '20px' }} />
                                                          </IconButton>
                                                        </Tooltip>
                                </div>
            <BoxWrapper boxTitle="24Q Filing">
                <ValidatorForm
                    useRef="form"
                    onSubmit={onSubmitHandler}
                    onError={(errors) => console.log(errors)}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={4} lg={4}>
                            <label>
                                Financial year<sup style={{ color: "red" }}>*</sup>:
                            </label>
                            <FormControl sx={{ minWidth: "100%" }}>
                                <Select
                                    labelId="demo-customized-select-label"
                                    id="demo-customized-select"
                                    value={year}
                                    onChange={(e) => setYear(e.target.value)}
                                    input={<BootstrapInput />}
                                    required
                                >
                                    {yearFromArr.map((v) => (
                                        <MenuItem key={v.id} value={v.year}>{v.year}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={4} lg={4}>
                            <label>
                                Quarter :
                            </label>
                            <FormControl sx={{ minWidth: "100%" }}>
                                <Select
                                    labelId="demo-customized-select-label"
                                    id="demo-customized-select"
                                    value={quarter}
                                    onChange={(e) => setQuarter(e.target.value)}
                                    input={<BootstrapInput />}
                                    required
                                >
                                    {Quter.map((v) => (
                                        <MenuItem key={v.id} value={v.id}>{v.value}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={4} lg={4} style={{ display: 'flex', flexDirection: 'row' }}>
                            <LoadingButton
                                loading={submitBtnLoading}
                                variant="contained"
                                type="submit"
                                sx={{ mt: '28px', width: '100px', py: '1px', mr: 2, backgroundColor: 'var(--app-bar-bg)', color: 'white' }}
                            >
                                Submit
                            </LoadingButton>
                            <button
                                className="button-outlined-secondary"
                                style={{ marginTop: "28px", width: "100px", padding: "1px" }}
                                type="button"
                                onClick={handleOpenAndCloseModel}
                            >
                                Cancel
                            </button>
                        </Grid>
                    </Grid>
                </ValidatorForm>
            </BoxWrapper>

            <BoxWrapper
                boxTitle="24Q Filing Report"
                searchInputPlaceholder="Search..."
                enableSearchInput={true}
                searchInputOnchange={handleSearch}
                enableAddButton={true}
                addButtonLabel="Refresh"
                addButtonHandlerFn={getApiForReport}
                // enableSecondButton={true}
                // secondButtonLabel="Reset"
                // secondButtonHandlerFn={handleReset} 
                enableIcon3={true}
                enableIcon3Value={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Typography variant="body1" sx={{ fontWeight: 600, fontFamily: 'Dosis, sans-serif', fontSize: '18px' }}>
                            Draft:
                        </Typography>
                        <Switch
                            checked={showDrafts}
                            onChange={(e) => setShowDrafts(e.target.checked)}
                            sx={{
                                '& .MuiSwitch-switchBase': {
                                    color: '#808080',
                                },
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: 'var(--app-bar-bg)',
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: 'var(--app-bar-bg)',
                                },
                                '& .MuiSwitch-track': {
                                    backgroundColor: '#fff',
                                    border: '1px solid #d3d3d3',
                                },
                            }}
                        />
                    </div>
                }
            >
                <div className="responsive-table">
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>Financial Year</th>
                                <th>TAN</th>
                                <th>Quarter</th>
                                <th>Fuv Files</th>
                                <th>Receipt File</th>
                                <th>Action</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredTableData?.map((value) => (
                                <React.Fragment key={value.id}>
                                    {value.is_draft ? (
                                        <tr>
                                            <td colSpan={8} style={{ padding: '0px', border: 'none' }}>
                                                <div style={{
                                                    border: '2px dotted #FFA726',
                                                    borderRadius: '8px',
                                                    position: 'relative',
                                                    backgroundColor: '#FFF9F0',
                                                    padding: '8px',
                                                    margin: '4px 0'
                                                }}>
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: '4px',
                                                        left: '8px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px',
                                                        backgroundColor: '#FFA726',
                                                        color: 'white',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        fontSize: '10px',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        DRAFT
                                                    </div>
                                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ width: '12.5%', padding: '4px', border: 'none' }}>{value.financial_year}</td>
                                                                <td style={{ width: '12.5%', padding: '4px', border: 'none' }}>{value.tan}</td>
                                                                <td style={{ width: '12.5%', padding: '4px', border: 'none' }}>{value.quarter}</td>
                                                                <td style={{ width: '12.5%', padding: '4px', border: 'none' }}>
                                                                    {value?.fvu_zip_url ? (
                                                                        <IconButton color="primary" size="small">
                                                                            <DownloadIcon
                                                                                onClick={() => onFUVFileExport(value.fvu_zip_file_binary, value.financial_year, value.quarter)}
                                                                                style={{ cursor: 'pointer' }} />
                                                                        </IconButton>
                                                                    ) : null}
                                                                </td>
                                                                <td style={{ width: '12.5%', padding: '4px', border: 'none' }}>
                                                                    {value?.receipt_file_url ? (
                                                                        <IconButton color="primary" size="small">
                                                                            <DownloadIcon
                                                                                onClick={() => onReceiptFileExport(value.receipt_file_binary, value.financial_year, value.quarter)}
                                                                                style={{ cursor: 'pointer' }} />
                                                                        </IconButton>
                                                                    ) : null}
                                                                </td>
                                                                <td style={{ width: '12.5%', padding: '4px', border: 'none' }}>
                                                                    {(value?.error_file_url || value?.error_file_binary) ? (
                                                                        <IconButton color="primary" size="small">
                                                                            <DownloadIcon
                                                                                onClick={() => onErrorFileExport(value.error_file_binary, value.error_file_type, value.financial_year, value.quarter)}
                                                                                style={{ cursor: 'pointer' }} />
                                                                        </IconButton>
                                                                    ) : null}
                                                                    {value?.status.toLowerCase() === 'failed' && (
                                                                        <>
                                                                            <IconButton
                                                                                color="error"
                                                                                size="small"
                                                                                onClick={() =>
                                                                                    setSnackbar({
                                                                                        open: true,
                                                                                        message: value?.error_message,
                                                                                        severity: 'error',
                                                                                    })
                                                                                }
                                                                            >
                                                                                <VisibilityIcon />
                                                                            </IconButton>
                                                                            <IconButton
                                                                                color="primary"
                                                                                size="small"
                                                                                onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                            >
                                                                                <VisibilityIcon />
                                                                            </IconButton>
                                                                        </>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'succeeded' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'reset' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'eligible' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'fvu_generated' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'fvu_failed' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'fvu_validation_failed' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'validation_failed' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'initiated' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'queued' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'fvu_ready' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'txt_generated' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'fvu_job_created' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                    {value?.status.toLowerCase() === 'efile_created' && (
                                                                        <IconButton
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                                        >
                                                                            <VisibilityIcon />
                                                                        </IconButton>
                                                                    )}
                                                                </td>
                                                                <td style={{ width: '12.5%', padding: '4px', border: 'none' }}>
                                                                    <Chip
                                                                        label={value?.status.toUpperCase()}
                                                                        color={
                                                                            value?.status.toLowerCase() === 'succeeded'
                                                                                ? 'success'
                                                                                : value?.status.toLowerCase() === 'failed'
                                                                                    ? 'error'
                                                                                    : value?.status.toLowerCase() === 'inprogress'
                                                                                        ? 'warning'
                                                                                        : 'default'
                                                                        }
                                                                        variant="outlined"
                                                                    />
                                                                </td>
                                                                <td style={{ width: '11.1%', padding: '4px', border: 'none' }}>
                                                                    {value?.is_reset && (
                                                                        <Button
                                                                            variant="contained"
                                                                            size="small"
                                                                            onClick={() => handleReset(value.id, value.financial_year, value.quarter)}
                                                                            sx={{
                                                                                textTransform: 'none',
                                                                                px: 2,
                                                                                py: 0.8,
                                                                                fontSize: '0.85rem',
                                                                                borderRadius: '8px',
                                                                                fontWeight: 500,
                                                                                minWidth: 90,
                                                                                boxShadow: 'none',
                                                                                backgroundColor: 'var(--app-bar-bg)',
                                                                                '&:hover': {
                                                                                    backgroundColor: 'var(--app-bar-bg)',
                                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                                                                    opacity: 0.9,
                                                                                },
                                                                            }}
                                                                        >
                                                                            Reset
                                                                        </Button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td>{value.financial_year}</td>
                                            <td>{value.tan}</td>
                                            <td>{value.quarter}</td>
                                            {/* <td>
                                                {value?.txt_url ? (
                                                    <IconButton color="primary" size="small">
                                                        <DownloadIcon
                                                            onClick={() => onTextFileExport(value.txt_file_binary, value.financial_year, value.quarter)}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </IconButton>
                                                ) : null}
                                            </td> */}
                                            <td>
                                                {value?.fvu_zip_url ? (
                                                    <IconButton color="primary" size="small">
                                                        <DownloadIcon
                                                            onClick={() => onFUVFileExport(value.fvu_package_binary, value.financial_year, value.quarter)}
                                                            style={{ cursor: 'pointer' }} />
                                                    </IconButton>
                                                ) : null}
                                            </td>
                                            <td>
                                                {value?.receipt_file_url ? (
                                                    <IconButton color="primary" size="small">
                                                        <DownloadIcon
                                                            onClick={() => onReceiptFileExport(value.receipt_file_binary, value.financial_year, value.quarter)}
                                                            style={{ cursor: 'pointer' }} />
                                                    </IconButton>
                                                ) : null}
                                            </td>
                                            <td>
                                                {(value?.error_file_url || value?.error_file_binary) ? (
                                                    <IconButton color="primary" size="small">
                                                        <DownloadIcon
                                                            onClick={() => onErrorFileExport(value.error_file_binary, value.error_file_type, value.financial_year, value.quarter)}
                                                            style={{ cursor: 'pointer' }} />
                                                    </IconButton>
                                                ) : null}
                                                {value?.status.toLowerCase() === 'failed' && (
                                                    <>
                                                        <IconButton
                                                            color="error"
                                                            size="small"
                                                            onClick={() =>
                                                                setSnackbar({
                                                                    open: true,
                                                                    message: value?.error_message,
                                                                    severity: 'error',
                                                                })
                                                            }
                                                        >
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            color="primary"
                                                            size="small"
                                                            onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                        >
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                    </>
                                                )}
                                                {value?.status.toLowerCase() === 'succeeded' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'reset' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'eligible' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'fvu_generated' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}{value?.status.toLowerCase() === 'fvu_failed' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'fvu_validation_failed' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'validation_failed' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'initiated' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'queued' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'fvu_ready' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'txt_generated' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'fvu_job_created' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                                {value?.status.toLowerCase() === 'efile_created' && (
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleDraftView(value.financial_year, value.quarter)}
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                )}
                                            </td>
                                            <td>
                                                <Chip
                                                    label={value?.status.toUpperCase()}
                                                    color={
                                                        value?.status.toLowerCase() === 'succeeded'
                                                            ? 'success'
                                                            : value?.status.toLowerCase() === 'failed'
                                                                ? 'error'
                                                                : value?.status.toLowerCase() === 'inprogress'
                                                                    ? 'warning'
                                                                    : 'default'
                                                    }
                                                    variant="outlined"
                                                />
                                            </td>
                                            <td>
                                                {value?.is_reset && (
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => handleReset(value.id, value.financial_year, value.quarter)}
                                                        sx={{
                                                            textTransform: 'none',
                                                            px: 2,
                                                            py: 0.8,
                                                            fontSize: '0.85rem',
                                                            borderRadius: '8px',
                                                            fontWeight: 500,
                                                            minWidth: 90,
                                                            boxShadow: 'none',
                                                            backgroundColor: 'var(--app-bar-bg)',
                                                            '&:hover': {
                                                                backgroundColor: 'var(--app-bar-bg)',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                                                opacity: 0.9,
                                                            },
                                                        }}
                                                    >
                                                        Reset
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                            {filteredTableData.length <= 0 && (
                                <tr>
                                    <td style={{ color: "red", textAlign: "center" }} colSpan={8}>
                                        No Data Found!!
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </BoxWrapper>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
